'use client';

/**
 * Hamburger button that toggles the `.nav-open` class on the surrounding
 * `.site-header` element. Extracted from the header so the header itself
 * can render as a server component.
 */
export function MobileNavToggle() {
  return (
    <button
      type="button"
      className="menu-toggle"
      aria-label="Toggle navigation"
      onClick={(e) => {
        const header = e.currentTarget.closest('.site-header');
        header?.classList.toggle('nav-open');
      }}
    >
      <span />
      <span />
    </button>
  );
}
